import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  IconModule,
  ItemCounterModule,
  MediaModule,
  OutletModule,
} from '@spartacus/storefront';
import { FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UigCartItemComponent } from './uig-cart-item/uig-cart-item.component';
import { UigCartItemListComponent } from './uig-cart-item-list/uig-cart-item-list.component';
import { UigOrderSummaryComponent } from './uig-order-summary/uig-order-summary.component';
import { UigCartNotesModule } from '../uig-cart-notes/uig-cart-notes.module';
import { UigItemCounterComponent } from './uig-item-counter/uig-item-counter.component';
import { UigAvailabilityModule } from '../../uig-product/uig-availability/uig-availability.module';
import {CartCouponModule} from "@spartacus/cart/base/components";
import { UigGroupedCartItemListComponent } from '../uig-cart-grouping/uig-grouped-cart-item-list/uig-grouped-cart-item-list.component';
import { UigMarketplaceIconModule } from '../../uig-product/uig-marketplace-icon/uig-marketplace-icon.module';
import { UigPipesModule } from 'src/app/pipes/uig-pipes.module';
import { UigShippingNoteModule } from '../uig-shipping-note/uig-shipping-note.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CartCouponModule,
    ReactiveFormsModule,
    UrlModule,
    NgbModule,
    I18nModule,
    IconModule,
    MediaModule,
    ItemCounterModule,
    FeaturesConfigModule,
    OutletModule,
    UigCartNotesModule,
    UigAvailabilityModule,
    UigMarketplaceIconModule,
    UigShippingNoteModule,
    UigPipesModule
  ],
  declarations: [
    UigCartItemComponent,
    UigCartItemListComponent,
    UigOrderSummaryComponent,
    UigItemCounterComponent,
    UigGroupedCartItemListComponent
  ],
  exports: [UigCartItemComponent, UigCartItemListComponent, UigOrderSummaryComponent, UigGroupedCartItemListComponent],
})
export class UigCartSharedModule {}
